import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import HomeButton from './HomeButton';
import LogoutButton from './LogoutButton';
import { useAuth } from '../context/AuthContext';

function Header() {
  const location = useLocation();
  const { user } = useAuth();
  const isHomePage = location.pathname === '/home';

  return (
    <AppBar position="static" sx={{ mb: 4 }}>
      <Toolbar>
        {!isHomePage && <HomeButton />}
        <img
          src="/images/academy_logo_small.png"
          alt="DeepAlert Academy"
          style={{
            height: '40px',
            marginLeft: isHomePage ? 0 : '24px',
            marginRight: '16px',
            // Subtle white halo to improve contrast on dark background
            filter: 'drop-shadow(0 0 1px rgba(255,255,255,0.9)) drop-shadow(0 0 4px rgba(255,255,255,0.45))'
          }}
        />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Training Academy
        </Typography>
        <Button color="inherit" href={process.env.REACT_APP_ADMIN_URL || 'http://localhost:3001'} target="_blank" rel="noopener noreferrer">
          Admin
        </Button>
        {user && (
          <>
            <Typography sx={{ mr: 2 }}>
              Welcome, {user.name}{user.surname ? ` ${user.surname}` : ''}
            </Typography>
            <LogoutButton />
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;
